import { graphql } from '@generated/gql';

export const FETCH_FORM_DEFINITIONS = graphql(/** GraphQL */ `
  query formDefinitionSelectFetchFormDefinitions(
    $input: FetchFormDefinitionsInput!
  ) {
    fetchFormDefinitions(input: $input) {
      formDefinitions {
        id
        key
        translatedName {
          ...FormTranslatedString
        }
        objectType
      }
      totalCount
    }
  }
`);
